<template>
  <div class="integrations">
    <div class="tabs">
      <div
        v-for="(item, index) of tabs"
        :key="index"
        :class="{ active: item.component === tab }"
        class="tab"
        @click="tab = item.component"
      >
        {{ item.title }}
      </div>
    </div>

    <div class="content-integrations">
      <component :is="tab" />
    </div>
  </div>
</template>

<script>
import Bitrix from '@/views/setting/integrations/Bitrix.vue'
import YandexGpt from '@/views/setting/integrations/YandexGpt.vue'

export default {
  name: 'Integrations',
  components: { Bitrix, YandexGpt },
  data() {
    return {
      tab: 'Bitrix',
      tabs: [
        {
          component: 'Bitrix',
          title: 'Битрикс24',
        },
        {
          component: 'YandexGpt',
          title: 'YandexGPT',
        },
      ],
    }
  },
}
</script>

<style lang="scss">
.integrations {
  width: 100%;

  .tabs {
    display: flex;
    gap: 8px;
    width: 100%;

    .tab {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 20px;
      font-weight: 500;
      width: max-content;
      height: 40px;
      padding: 0 20px;
      border-radius: 5px;
      cursor: pointer;

      &.active {
        background: #0088cc;
        color: #fff;
      }
    }
  }

  .content-integrations {
    width: 100%;
    margin-top: 20px;
  }
}
</style>
